/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let confrenceUserCountURL = root.confrenceUserCountUrl.link;
let confrenceUserCountCreateURL = root.confrenceUserCountCreateUrl.link;
let confrenceUserCountLeftURL = root.confrenceUserCountLeftUrl.link;
let getPublicVistaMeetingApiUrl = root.getPublicVistaMeetingApiUrl.link;
let conferenceInfoApiUrl = root.conferenceInfoApiUrl.link;
export default {
  state: {
    getPublicVistaMeetingState:{},
  },
  mutations: {
    getPublicVistaMeetingMut(state, value) {
      Vue.set(state, 'getPublicVistaMeetingState', value);
    },
  },
  actions: {
    // confrence Info 
    conferenceInfo(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(conferenceInfoApiUrl, payload).then(res => {
                resolve(res.data.data);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // confrence User Count
    getPublicVistaMeetingFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getPublicVistaMeetingApiUrl, payload).then(res => {
                context.commit('getPublicVistaMeetingMut', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // confrence User Count
    confrenceUserCountFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(confrenceUserCountURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // confrence User Count
    confrenceUserCountCreatedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(confrenceUserCountCreateURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // confrence User Count
    confrenceUserCountLeftedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(confrenceUserCountLeftURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
    getPublicVistaMeetingGetters: state => state.getPublicVistaMeetingState,
  }
}